import React, { FunctionComponent, PropsWithChildren } from "react";
import grayLoader from "~/assets/loader-ring-gray.png";
import whiteLoader from "~/assets/loader-ring-white.png";
import loader from "~/assets/loader-ring.png";

interface LoaderProps {
  className?: string;
  size?: number;
  color?: string;
  thickness?: number;
  height?: string;
  isShowPng?: boolean;
  isGray?: boolean;
  isWhite?: boolean;
}

export const Loader: FunctionComponent<PropsWithChildren<LoaderProps>> =
  React.memo(
    ({
      children,
      className = "",
      size = 24,
      color = "currentColor",
      thickness = 2,
      isShowPng = false,
      isGray = false,
      isWhite = false,
    }) => {
      return (
        <div
          className={`flex flex-col justify-center items-center ${className}`}
        >
          {isShowPng ? (
            <img
              src={isGray ? grayLoader : isWhite ? whiteLoader : loader}
              alt="Loading..."
              className={`animate-spin ${className}`}
              style={{ contain: "layout style paint" }}
            />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={size}
              height={size}
              viewBox="0 0 24 24"
              fill="none"
              stroke={color}
              strokeWidth={thickness}
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`animate-spin will-change-transform ${className}`}
              style={{ contain: "layout style paint" }}
            >
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
          )}
          {children}
        </div>
      );
    }
  );
